import { render, staticRenderFns } from "./HomeFooterIndex.vue?vue&type=template&id=35341986&scoped=true"
import script from "./HomeFooterIndex.vue?vue&type=script&lang=js"
export * from "./HomeFooterIndex.vue?vue&type=script&lang=js"
import style0 from "./HomeFooterIndex.vue?vue&type=style&index=0&id=35341986&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35341986",
  null
  
)

export default component.exports